// @flow
export const VIEW_TYPES_FILTER_CLEAR: 'reports/VIEW_TYPES_FILTER_CLEAR' = 'reports/VIEW_TYPES_FILTER_CLEAR';
export const VIEW_TYPES_FILTER_DELETE: 'reports/VIEW_TYPES_FILTER_DELETE' = 'reports/VIEW_TYPES_FILTER_DELETE';
export const VIEW_TYPES_FILTER_SET: 'reports/VIEW_TYPES_FILTER_SET' = 'reports/VIEW_TYPES_FILTER_SET';
export const VIEW_TYPES_FILTER_UPDATE: 'reports/VIEW_TYPES_FILTER_UPDATE' = 'reports/VIEW_TYPES_FILTER_UPDATE';
